import React from 'react';
import { Stack, Typography, List } from '@mui/material';
import PageContainer from 'pages/PageContainer';
import { TermsAndConditionsLists } from 'shared/constants/legal-pages-constants/terms-and-conditions-constants';
import { HomeLink } from 'components/LegalPagesLinks/HomeLink';
import { MailToLink } from 'components/LegalPagesLinks/MailToLink';
import { CustomListItem } from 'components/List/CustomListItem/CustomListItem';

const TermsAndConditions: React.FunctionComponent = () => (
  <PageContainer showMenu={false}>
    <Stack py={{ xs: 0, md: 4 }} rowGap="64px" width="100%" maxWidth="1200px" mx="auto">
      <Typography variant="h1">Terms & Conditions</Typography>
      <Stack rowGap="16px">
        <Typography variant="body2">Effective Date: September 1, 2025</Typography>
        <Typography variant="body2">
          {'These Terms & Conditions (“Terms”) govern your use of the '}
          <HomeLink />
          {' online video debate platform operated by '}
          <HomeLink />
          {` (“we,” “our,” or “us”). 
          By accessing or using our website, applications, and related services (collectively, the “Services”), 
          you agree to these Terms. If you do not agree, do not use the Services.`}
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          1. The Service
        </Typography>
        <Typography variant="body2">
          <HomeLink />
          {` is an online platform for structured video debates. 
            Users may host debates, join as participants, or watch as viewers. 
            The Services include live streaming, chat, and related interactive features.`}
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          2. User Obligations
        </Typography>
        <Typography variant="body2">
          {'When using '}
          <HomeLink />
          {', you agree to: '}
        </Typography>
        <List className="list-legal-pages">
          {TermsAndConditionsLists.UserObligations.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          3. Platform Rights
        </Typography>
        <Typography variant="body2">We reserve the right to: </Typography>
        <List className="list-legal-pages">
          {TermsAndConditionsLists.PlatformRights.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
        <Typography variant="body2">
          We are not obligated to monitor user content but may do so to enforce these Terms.
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          4. User-Generated Content
        </Typography>
        <List className="list-legal-pages">
          {TermsAndConditionsLists.UserGeneratedContent.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
        <Typography variant="body2">
          We are not responsible for the accuracy, legality, or appropriateness of User Content.
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          5. Intellectual Property
        </Typography>
        <Typography variant="body2">
          {'All rights to the '}
          <HomeLink />
          {` platform, including its software, design, trademarks, and logos, are owned by Deb8.TV. 
          Except for your User Content, you may not copy, modify, distribute, 
          or create derivative works of our Services without prior written permission.`}
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          6. Disclaimers and Limitations of Liability
        </Typography>
        <List className="list-legal-pages">
          {TermsAndConditionsLists.DisclaimersAndLimitationsOfLiability.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          7. Governing Law
        </Typography>
        <Typography variant="body2">
          These Terms are governed by the laws of the State of Delaware, without regard to its
          conflict of law principles. Any disputes will be resolved in the state or federal courts
          located in Delaware.
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          8. Changes to Terms
        </Typography>
        <Typography variant="body2">
          We may update these Terms from time to time. If we make material changes, we will notify
          you by posting the revised Terms with a new effective date. Continued use of the Services
          means you accept the changes.
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          9. Contact Us
        </Typography>
        <Typography variant="body2">
          If you have questions about these Terms, contact us at:
        </Typography>
        <Typography variant="body2" fontWeight={700}>
          Deb8.TV
        </Typography>
        <Typography variant="body2">
          {'Email: '}
          <MailToLink />
        </Typography>
      </Stack>
    </Stack>
  </PageContainer>
);

export default TermsAndConditions;
